export const mainUrls = {
  api: 'v2node/api/'
};

export const endpoints = {
  content: `${mainUrls.api}content/`,
  metadata:`${mainUrls.api}/`,
  notification: `${mainUrls.api}notification/`,
  question: `${mainUrls.api}question/`,
  workspace: `${mainUrls.api}workspace/`,
  archivedworkspace:`${mainUrls.api}archivedworkspace/`,
  templateworkspace:`${mainUrls.api}templateworkspace/`,
  report: `${mainUrls.api}report/`,
  documentRequest: `${mainUrls.api}document-request/`,
  task: `${mainUrls.api}task/`,
  twilio:`${mainUrls.api}twilio/`,
  kanban: `${mainUrls.api}kanban/`
  
};
